import { BookingArriveComponent } from './pages/booking-arrive/booking-arrive.component';
import { DoAbnormalComponent } from './pages/do-abnormal/do-abnormal.component';
import { MergeKeySearchComponent } from './pages/merge-key-search/merge-key-search.component';
import { ReceivingInstructionComponent } from './pages/receiving-instruction/receiving-instruction.component';
import { PurchaseSearchComponent } from './pages/purchase-search/purchase-search.component';
import { CustomerSignatureSampleStampComponent } from './pages/customer-signature-sample-stamp/customer-signature-sample-stamp.component';
import { ShipmentProgressComponent } from './pages/shipment-progress/shipment-progress.component';
import { WarehousingRmbPriceImportComponent } from './pages/warehousing-search/warehousing-rmb-price-import/warehousing-rmb-price-import.component';
import { ImportHeaderEditComponent } from './pages/import-header-edit/import-header-edit.component';
import { ImportHeaderDetailComponent } from './pages/import-header-detail/import-header-detail.component';
import { ImportSearchComponent } from './pages/import-search/import-search.component';
import { DhlEditComponent } from './pages/dhl-edit/dhl-edit.component';
import { ForwarderEditComponent } from './pages/forwarder-edit/forwarder-edit.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DoSearchComponent } from './pages/do-search/do-search.component';
import { DoDetailComponent } from './pages/do-detail/do-detail.component';
import { BookingSearchComponent } from './pages/booking-search/booking-search.component';
import { BookingHeaderEditComponent } from './pages/booking-header-edit/booking-header-edit.component';
import { BookingHeaderDetailComponent } from './pages/booking-header-detail/booking-header-detail.component';
import { DoSearchForShippingComponent } from './pages/do-search-for-shipping/do-search-for-shipping.component';
import { PickingAssignmentComponent } from './pages/picking-assignment/picking-assignment.component';
import { BookingSearchForForwarderComponent } from './pages/booking-search-for-forwarder/booking-search-for-forwarder.component';
import { ExportSearchComponent } from './pages/export-search/export-search.component';
import { ContainerManagementComponent } from './pages/container-management/container-management.component';
import { ExportHeaderDetailComponent } from './pages/export-header-detail/export-header-detail.component';
import { ExportHeaderEditComponent } from './pages/export-header-edit/export-header-edit.component';
import { ExportHeaderAddComponent } from './pages/export-header-add/export-header-add.component';
import { BookingSearchForForwarderHeaderDetailComponent } from './pages/booking-search-for-forwarder-header-detail/booking-search-for-forwarder-header-detail.component';
import { WarehousingCreationComponent } from './pages/warehousing-creation/warehousing-creation.component';
import { LeaveWarehouseComponent } from './pages/leave-warehouse/leave-warehouse.component';
import { BookingSearchForForwarderHeaderEditComponent } from './pages/booking-search-for-forwarder-header-edit/booking-search-for-forwarder-header-edit.component';
import { WarehousingSearchComponent } from './pages/warehousing-search/warehousing-search.component';
import { WarehousingEditComponent } from './pages/warehousing-edit/warehousing-edit.component';
import { WarehousingUploadComponent } from './pages/warehousing-creation/warehousing-upload/warehousing-upload.component';
import { WarehousingHeaderDetailComponent } from './pages/warehousing-header-detail/warehousing-header-detail.component';
import { BatchUpdateBookingComponent } from './pages/batch-update-booking/batch-update-booking.component';
import { InOutWarehousingComponent } from './pages/in-out-warehousing/in-out-warehousing.component';
import { ShipmentProgessSearchComponent } from './pages/shipment-progess-search/shipment-progess-search.component';
import { AdvisingAbnormalComponent } from './pages/advising-abnormal/advising-abnormal.component';
import { InboundProgressComponent } from './pages/inbound-progress/inbound-progress.component';
import { ForwarderCooperationComponent } from './pages/forwarder-cooperation/forwarder-cooperation.component';
import { FreightTrialCalculationComponent } from './pages/freight-trial-calculation/freight-trial-calculation.component';
import { FreightSearchComponent } from './pages/freight-search/freight-search.component';
import { DoDetailForShippingComponent } from './pages/do-detail-for-shipping/do-detail-for-shipping.component';
import { IntransitUpdateComponent } from './pages/intransit-update/intransit-update.component';
import { AutoprintReprintComponent } from './pages/autoprint-reprint/autoprint-reprint.component';
import { RegistrationFormComponent } from './pages/registration-form/registration-form.component';
import { RegistrationFormSearchComponent } from './pages/registration-form-search/registration-form-search.component';
import { PoSearchComponent } from './pages/po-search/po-searchcomponent';
import { PoConvertAdComponent } from './pages/po-search/po-convert-ad/po-convert-ad.component';
import { MaterialDocumentComponent } from './pages/material-document/material-document.component';
import { WarehousingAbnormalComponent } from './pages/warehousing-abnormal/warehousing-abnormal.component';
import {OverDcSearchComponent} from './pages/over-dc-search/over-dc-search.component';
import { MSDCIQCComponent } from './pages/msdc-iqc/msdc-iqc.component';
import { MSDCSearchComponent } from './pages/msdc-search/msdc-search.component';
import { ManualAllocationComponent } from './pages/manual-allocation/manual-allocation.component';
import { ManualAllocationWMSComponent } from './pages/manual-allocation/manual-allocation-wms/manual-allocation-wms.component';
import { CreateDoComponent } from './pages/create-do/create-do.component';
import { CustomsClearanceShippingReportComponent } from './pages/customs-clearance-shipping-report/customs-clearance-shipping-report.component';
import { MixCartonSearchComponent } from './pages/mix-carton-search/mix-carton-search.component';
import { AllocationConstraintComponent } from './pages/allocation-constraint/allocation-constraint.component';
import { AllocationConstraintInboundComponent } from './pages/allocation-constraint-inbound/allocation-constraint-inbound.component';
import { VmiAdvisingComponent } from './pages/vmi-advising/vmi-advising.component';
import { AsnInfoSearchComponent } from '../setting/pages/asn-info-search/asn-info-search.component';
import { TruckCostAllocationComponent } from './pages/truck-cost-allocation/truck-cost-allocation.component';
import { VmiDOCreateComponent } from './pages/vmi-do-create/vmi-do-create.component';
import { CustomerLabelComponent } from './pages/customer-label/customer-label.component';
import { IQCStatusSearchComponent } from './pages/iqc-status-search/iqc-status-search.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children:[
      {
        path: 'BookingCreation',
        loadChildren: () =>
          import('src/app/features/transport-operation/pages/booking-creation/booking-creation.module')
            .then(m => m.BookingCreationModule)
      },
      {
        path: 'DOSearch',
        component: DoSearchComponent
      },
      {
        path: 'DODetail',
        component: DoDetailComponent
      },
      {
        path: 'DOSearchForShipping',
        component: DoSearchForShippingComponent
      },
      {
        path: 'BookingSearch',
        component: BookingSearchComponent
      },
      {
        path: 'BookingSearchForForwarder',
        component: BookingSearchForForwarderComponent
      },
      {
        path: 'BookingHeaderEdit',
        component: BookingHeaderEditComponent
      },
      {
        path: 'BookingHeaderDetail',
        component: BookingHeaderDetailComponent
      },
      {
        path: 'PickingAssignment',
        component: PickingAssignmentComponent
      },
      {
        path: 'ContainerManagement',
        component: ContainerManagementComponent
      },
      {
        path: 'ExportSearch',
        component: ExportSearchComponent
      },
      {
        path: 'ExportHeaderDetail',
        component: ExportHeaderDetailComponent
      },
      {
        path: 'ExportHeaderEdit',
        component: ExportHeaderEditComponent
      },
      {
        path: 'ExportHeaderAdd',
        component: ExportHeaderAddComponent
      },
      {
        path: 'DHLEdit',
        component: DhlEditComponent
      },
      {
        path: 'BookingSearchForForwarderHeaderDetail',
        component: BookingSearchForForwarderHeaderDetailComponent
      },
      {
        path: 'LeaveWarehouse',
        component: LeaveWarehouseComponent
      },
      {
        path: 'BookingSearchForForwarderHeaderEdit',
        component: BookingSearchForForwarderHeaderEditComponent
      },
      {
        path: 'ImportSearch',
        component: ImportSearchComponent
      },
      {
        path: 'WarehousingCreation',
        component: WarehousingCreationComponent
      },
      {
        path: 'ImportHeaderDetail',
        component: ImportHeaderDetailComponent
      },
      {
        path: 'WarehousingSearch',
        component: WarehousingSearchComponent
      },
      {
        path: 'ImportHeaderEdit',
        component: ImportHeaderEditComponent
      },
      {
        path: 'WarehousingEdit',
        component: WarehousingEditComponent
      },
      {
        path: 'WarehousingUpload',
        component: WarehousingUploadComponent
      },
      {
        path: 'WarehousingHeaderDetail',
        component: WarehousingHeaderDetailComponent
      },
      {
        path: 'WarehousingRmbPriceImport',
        component: WarehousingRmbPriceImportComponent
      },
      {
        path: 'BatchUpdateBooking',
        component: BatchUpdateBookingComponent
      },
      {
        path: 'ReceivingInstruction',
        component: ReceivingInstructionComponent
      },
      {
        path: 'InOutWarehousing',
        component: InOutWarehousingComponent
      },
      {
        path: 'ShipmentProgress',
        component: ShipmentProgressComponent
      },
      {
        path: 'AdvisingAbnormal',
        component: AdvisingAbnormalComponent
      },
      {
        path: 'InOutWarehousing',
        component: InOutWarehousingComponent
      },
      {
        path: 'FreightTrialCalculation',
        component: FreightTrialCalculationComponent
      },
      {
        path: 'ForwarderCooperation',
        component: ForwarderCooperationComponent
      },
      {
        path: 'ShipmentProgressSearch',
        component: ShipmentProgessSearchComponent
      },
      {
        path: 'MergeKeySearch',
        component: MergeKeySearchComponent
      },
      {
        path: 'InboundProgress',
        component: InboundProgressComponent
      },
      {
        path: 'Purchase',
        component: PurchaseSearchComponent
      },
      {
        path: 'DOAbnormal',
        component: DoAbnormalComponent
      },
      {
        path: 'CustomerSignatureSampleStamp',
        component: CustomerSignatureSampleStampComponent
      },
      {
        path: 'FreightSearch',
        component: FreightSearchComponent
      },
      {
        path: 'BookingArrive',
        component: BookingArriveComponent
      },
      {
        path: 'IntransitUpdate',
        component: IntransitUpdateComponent
      },
      {
        path: 'DoDetailForShipping',
        component: DoDetailForShippingComponent
      },
      {
        path: 'RegistrationForm',
        component: RegistrationFormComponent
      },
      {
        path: 'RegistrationFormSearch',
        component: RegistrationFormSearchComponent
      },
      {
        path: 'AutoPrintReprint',
        component: AutoprintReprintComponent
      },
      {
        path: 'PoSearch',
        component: PoSearchComponent
      },
      {
        path: 'PoConvertAd',
        component: PoConvertAdComponent
      },
      {
        path: 'MaterialDocument',
        component: MaterialDocumentComponent
      },
      {
        path: 'WarehousingAbnormal',
        component: WarehousingAbnormalComponent
      },
      {
        path: 'OverDcSearch',
        component: OverDcSearchComponent
      },
      {
        path: 'MSDCIQC',
        component: MSDCIQCComponent
      },
      {
        path: 'MSDC',
        component: MSDCSearchComponent
      },
      {
        path: 'ManualAllocation',
        component: ManualAllocationComponent
      },
      {
        path: 'ManualAllocationWMS',
        component: ManualAllocationWMSComponent
      },
      {
        path: 'CreateDo',
        component: CreateDoComponent
      },
      {
        path: 'CustomsClearanceShippingReport',
        component: CustomsClearanceShippingReportComponent
      },
      {
        path: 'MixCartonSearch',
        component: MixCartonSearchComponent
      },
      {
        path: 'AllocationConstraint',
        component: AllocationConstraintComponent
      },
      {
        path: 'AllocationConstraintInbound',
        component: AllocationConstraintInboundComponent
      },
      {
        path: 'AsnInfoSearch',
        component: AsnInfoSearchComponent
      },
      {
        path: 'VmiAdvising',
        component: VmiAdvisingComponent,
      },
      {
        path: 'TruckCostAllocation',
        component: TruckCostAllocationComponent
      },
      {
        path: 'VmiDOCreate',
        component: VmiDOCreateComponent,
      },
      {
        path: 'ForwarderInfoEdit',
        component: ForwarderEditComponent,
      },
      {
        path: 'CustomerLabelMaintenance',
        component: CustomerLabelComponent
      },
      {
        path: 'IQCStatusSearch',
        component: IQCStatusSearchComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransportOperationRoutingModule { }
